import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ProtectedContent from './components/auth/protectedContent';
import { UnauthorizedPage } from "./pages";
import { UnsubscribePage } from './pages/unsubscribe/unsubscribePage';

// 🔐 Neu
import Axios from "axios";
import apiConfig from "./common/config/api.config";

// 🔐 Einmalige Axios-Initialisierung
const cfg = apiConfig();
Axios.defaults.baseURL = cfg.url;

const App = () => {
  return <>
    <BrowserRouter>
      <Switch>
        <Route path="/key" render={({ match: { path } }) => (
          <Switch>
            <Route exact path={path + "/:id"} component={ProtectedContent} />
            <Route exact path={path + "/:id/kundeninformation/:kundeninformation"} component={ProtectedContent} />
            <Route exact path={path + "/:id/branch/:branch/deptid/:deptid"} component={ProtectedContent} />

            <Route path="*" children={UnauthorizedPage} />
          </Switch>
        )}>
        </Route>
        <Route path="/unsubscribe" render={({ match: { path } }) => (
          <Switch>
            <Route exact path={`${path}/:mailadress`} component={UnsubscribePage} />
            <Route path="*" children={UnauthorizedPage} />
          </Switch>
        )}>
        </Route>
        <Route path="/static/media/*" render={() => null} />
        <Route path="*" children={UnauthorizedPage} />
      </Switch>
    </BrowserRouter>
  </>
}

export default App;
